import { render, staticRenderFns } from "./IngresoExpedientePdf.vue?vue&type=template&id=7728c4ec"
import script from "./IngresoExpedientePdf.vue?vue&type=script&lang=js"
export * from "./IngresoExpedientePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports